import { render } from "./OddsResult.vue?vue&type=template&id=23dd6b9f&scoped=true"
import script from "./OddsResult.vue?vue&type=script&lang=js"
export * from "./OddsResult.vue?vue&type=script&lang=js"

import "./OddsResult.vue?vue&type=style&index=0&id=23dd6b9f&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-fj-SSR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23dd6b9f"]])

export default __exports__